import {
  Box,
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  OutlinedInput,
  Select,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Modal from "react-awesome-modal";
import { Field, Form, Formik, ErrorMessage } from "formik";
import { addBookSchema } from "./modalForms";
import { backend } from "../../../../../api";

import { DropzoneArea } from "material-ui-dropzone";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  modalContainer: {
    width: "90%",
    margin: "20px auto",
  },
  modalHeading: {
    fontSize: 24,
    fontWeight: 550,
    marginBottom: 0,
  },
  modalLine: {
    margin: "20px auto",
    width: "100%",
    color: theme.palette.secondary.dark,
  },
  fieldLabel: {
    color: theme.palette.secondary.light,
    marginBottom: "8px",
    fontSize: "15px",
    fontWeight: 500,
  },
  inputField: {
    padding: "10px",
    borderRadius: "2px",
  },
  submitBtn: {
    color: theme.palette.secondary.light,
    backgroundColor: theme.palette.primary.main,
    width: 100,
    borderRadius: 2,
    padding: "8px 0",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: "white",
    },
  },
  cancelBtn: {
    backgroundColor: theme.palette.secondary.dark,
    width: 100,
    borderRadius: 2,
    padding: "8px 0",
    color: theme.palette.secondary.light,
  },
  dropZoneContainer: {
    // backgroundColor:'yellow',
    padding: "0 5px",
    maxHeight: 100,
    margin: 0,
    // overflow: 'hidden',
    // marginTop: '-30px'
  },
  text: {
    color: "red",
  },
  preview: {
    backgroundColor: "red",
    marginTop: "-50px",
    padding: 0,
    maxHeight: 50,
  },
  prevviewImage: {
    margin: 0,
  },
}));

function AddBook(props) {
  const { visible, closeModal } = props;
  let formData;
  const classes = useStyles();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchCategory();
  }, []);
  const fetchCategory = () => {
    backend
      .get("/category")
      .then((res) => {
        if (res.data.message === "Book Category Found Successfully") {
          setCategories(res.data.data.map((item) => item.category_name));
        }
      })
      .catch((err) => {
        toast.error(err.response ? err.response.data.message : err.message);
      });
  };
  const uploadFileToS3 = (file, setFieldValue) => {
    setFieldValue("cover", "");
    formData = new FormData();
    formData.append("files", file);
    backend
      .post("/file/fileUpload", formData)
      .then((res) => {
        if (res.status === 200) {
          // setFieldValue('cover', res.data.locationArray.fileLocation)
        }
      })
      .catch((err) => {
        toast.error(err.response ? err.response.data.message : err.message);
      });
  };
  return (
    <Modal
      visible={visible}
      width="500"
      effect="fadeInUp"
      onClickAway={closeModal}
    >
      <div className={classes.modalContainer}>
        <h3 className={classes.modalHeading}>Add Book</h3>
        <hr className={classes.modalLine} />

        <Formik
          initialValues={{
            title: "",
            cover: "",
            category: "Biography",
            story: "",
          }}
          onSubmit={(values) => console.log(values)}
          validationSchema={addBookSchema}
        >
          {({ errors, values, setFieldValue }) => {
            return (
              <Form>
                <Box mb={2}>
                  <InputLabel className={classes.fieldLabel}>Title</InputLabel>
                  <Field
                    type="text"
                    name="title"
                    as={OutlinedInput}
                    fullWidth
                    error={errors.title}
                    className={classes.inputField}
                  />
                  <ErrorMessage name="title">
                    {(error) => (
                      <Typography variant="subtitle2" color="error">
                        {error}
                      </Typography>
                    )}
                  </ErrorMessage>
                </Box>
                <Box mb={2}>
                  <InputLabel className={classes.fieldLabel}>Cover</InputLabel>
                  {/* <Field type="text" name="cover" as={OutlinedInput} fullWidth error={errors.title} className={classes.inputField} /> */}
                  {/* <Dropzone
                                        getUploadParams={getUploadParams}
                                        onChangeStatus={handleChangeStatus}
                                        onSubmit={handleSubmit}
                                        accept="image/*"
                                    /> */}
                  <DropzoneArea
                    onChange={(files) =>
                      uploadFileToS3(files[0], setFieldValue)
                    }
                    filesLimit={1}
                    dropzoneText={
                      <p style={{ fontSize: 8 }}>Upload Image for Book Cover</p>
                    }
                    style={{ maxHeight: 100 }}
                    previewGridClasses={{
                      container: classes.dropZoneContainer,
                      item: classes.preview,
                      image: classes.prevviewImage,
                    }}
                  />
                  <ErrorMessage name="cover">
                    {(error) => (
                      <Typography variant="subtitle2" color="error">
                        {error}
                      </Typography>
                    )}
                  </ErrorMessage>
                </Box>
                <Box mb={2}>
                  <InputLabel className={classes.fieldLabel}>
                    Category
                  </InputLabel>
                  {/* <Field type="text" name="title" as={OutlinedInput} fullWidth error={errors.title} className={classes.inputField} /> */}
                  <FormControl variant="outlined" fullWidth>
                    <Select
                      native
                      onChange={(e) =>
                        setFieldValue("category", e.target.value)
                      }
                    >
                      {categories.map((item) => (
                        <option value={item}>{item}</option>
                      ))}
                    </Select>
                  </FormControl>
                  <ErrorMessage name="category">
                    {(error) => (
                      <Typography variant="subtitle2" color="error">
                        {error}
                      </Typography>
                    )}
                  </ErrorMessage>
                </Box>
                <Box mb={2}>
                  <InputLabel className={classes.fieldLabel}>Story</InputLabel>
                  <Field
                    type="text"
                    name="story"
                    rows={5}
                    multiline
                    as={OutlinedInput}
                    fullWidth
                    error={errors.title}
                    className={classes.inputField}
                  />
                  <ErrorMessage name="story">
                    {(error) => (
                      <Typography variant="subtitle2" color="error">
                        {error}
                      </Typography>
                    )}
                  </ErrorMessage>
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Button className={classes.cancelBtn} onClick={closeModal}>
                    Cancel
                  </Button>
                  <Button className={classes.submitBtn} type="submit">
                    Update
                  </Button>
                </Box>
              </Form>
            );
          }}
        </Formik>
      </div>
    </Modal>
  );
}

export default AddBook;
